import { render } from "./CatalogoRubricas.vue?vue&type=template&id=a339f34a&scoped=true"
import script from "./CatalogoRubricas.vue?vue&type=script&lang=js"
export * from "./CatalogoRubricas.vue?vue&type=script&lang=js"

import "./CatalogoRubricas.vue?vue&type=style&index=0&id=a339f34a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a339f34a"]])

export default __exports__